import { LoyaltyAccountDataType } from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import type { PropsWithChildren, RefObject } from 'react';
import { createContext, useCallback, useMemo, useRef } from 'react';

export const PaybackFetchMethodContext = createContext<{
  setFetchMethod: (fetchType: LoyaltyAccountDataType) => void;
  fetchMethodRef: RefObject<LoyaltyAccountDataType>;
}>({
  setFetchMethod: () => {},
  fetchMethodRef: { current: LoyaltyAccountDataType.AllUpdated },
});

export type PaybackAccountDataFetchProviderProps = {};

export const PaybackAccountDataFetchProvider: React.FC<
  PropsWithChildren<PaybackAccountDataFetchProviderProps>
> = ({ children }) => {
  const fetchMethodRef = useRef(LoyaltyAccountDataType.AllUpdated);
  const setFetchMethod = useCallback((fetchType: LoyaltyAccountDataType) => {
    fetchMethodRef.current = fetchType;
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const contextValue = useMemo(() => ({ setFetchMethod, fetchMethodRef }), []);
  return (
    <PaybackFetchMethodContext.Provider value={contextValue}>
      {children}
    </PaybackFetchMethodContext.Provider>
  );
};
